import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

import {ItemKey} from "../item/core/ItemKey";
import {Currency} from "../currency/Currency";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {CurrencyCorrection} from "@/modules/redactor/models/currency/CurrencyCorrection";


export class RewardModel extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(RewardModel, v) : SKIP;
            },
            (v) => {
                return deserialize(RewardModel, v);
            }
        );
    }

    constructor() {
        super();

        this._key = null;
        this._money = [];
        this._items = [];
        this._packages = [];

        this._cards = [];
        this._cardPackages = [];

        this._avatar = null;
        this._points = 0;
        this._percent = 0;
        this._product = null;
        this._currencyCorrection = [];
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get money() {
        return this._money;
    }

    set money(value) {
        this._money = value;
    }

    get items() {
        return this._items;
    }

    set items(value) {
        this._items = value;
    }

    get packages() {
        return this._packages;
    }

    set packages(value) {
        this._packages = value;
    }


    get cards() {
        return this._cards;
    }

    set cards(value) {
        this._cards = value;
    }

    get cardPackages() {
        return this._cardPackages;
    }

    set cardPackages(value) {
        this._cardPackages = value;
    }


    get avatar() {
        return this._avatar;
    }

    set avatar(value) {
        this._avatar = value;
    }

    get points() {
        return this._points;
    }

    set points(value) {
        this._points = value;
    }

    get percent() {
        return this._percent;
    }

    set percent(value) {
        this._percent = value;
    }

    get product() {
        return this._product;
    }

    set product(value) {
        this._product = value;
    }

    get currencyCorrection() {
        return this._currencyCorrection;
    }

    set currencyCorrection(value) {
        this._currencyCorrection = value;
    }

    valid() {

        if (!Number.isInteger(this.points) || this.points < 0) {
            return false;
        }

        if (!Number.isInteger(this.percent) || this.percent < 0 || this.percent > 100) {
            return false;
        }

        if (this.money && this.money.some(v => !v || !v.valid() || v.free())) {
            return false;
        }

        if (this.items && this.items.some(v => !v || !v.valid() || v.any())) {
            return false;
        }

        if (this.items && this.items.some(v => !RedactorUtils.getItems().some(item => item.key?.equal(v)))) {
            console.log('Invalid config: Missing Item for one of reward items');
            return false;
        }

        if (this.packages && this.packages.some(v => !v || !RedactorUtils.getRewardPackage(v, true))) {
            return false;
        }

        if (this.cards && this.cards.some(v => !v || !RedactorUtils.getCard(v))) {
            return false;
        }

        if (this.cardPackages && this.cardPackages.some(v => !v || !RedactorUtils.getCardPackage(v))) {
            return false;
        }

        if (this.avatar && !RedactorUtils.getAvatar(this.avatar)) {
            return false;
        }

        if (this.product && !RedactorUtils.getProduct(this.product)) {
            return false;
        }

        return true;
    }

    empty() {
        return (!this.money || this.money.length === 0) &&
            (!this.items || this.items.length === 0) &&
            (!this.packages || this.packages.length === 0) &&
            (!this.cards || this.cards.length === 0) &&
            (!this.cardPackages || this.cardPackages.length === 0) &&
            (!this.avatar);
    }

    copy() {
        return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new RewardModel());
        } else if (target instanceof RewardModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(RewardModel, {
    _key: alias("key", Schema.primitive()),

    _money: alias("money", list(Currency.schema())),
    _items: alias("items", list(ItemKey.schema())),
    _packages: alias("packages", list(Schema.primitive())),

    _cards: alias("cards", list(Schema.primitive())),
    _cardPackages: alias("card_packages", list(Schema.primitive())),

    _avatar: alias("avatar", Schema.primitive()),
    _points: alias("points", Schema.primitive()),
    _percent: alias("percent", Schema.primitive()),
    _product: alias("product", Schema.primitive()),
    _currencyCorrection: alias("currency_correction", list(CurrencyCorrection.schema())),
})
